module.exports = __webpack_public_path__ + "media/components/assets/icons/sidebar_class-db8b9bb6a069af557c0d53d248515649.svg";